import _extends from "/opt/build/repo/node_modules/.pnpm/next@15.5.6_@babel+core@7.28.5_@opentelemetry+api@1.9.0_@playwright+test@1.56.1_babel-p_096ab9bbeffdff0fc88514782f3793fe/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js";
import _objectWithoutPropertiesLoose from "/opt/build/repo/node_modules/.pnpm/next@15.5.6_@babel+core@7.28.5_@opentelemetry+api@1.9.0_@playwright+test@1.56.1_babel-p_096ab9bbeffdff0fc88514782f3793fe/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js";
var _excluded = ["onClose", "open"];
import { styled, useTheme, useColorScheme } from '@mui/material/styles';
import Drawer from '@mui/material/Drawer';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import ToggleButton from '@mui/material/ToggleButton';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import LightModeIcon from '@mui/icons-material/LightMode';
import DarkModeOutlinedIcon from '@mui/icons-material/DarkModeOutlined';
import SettingsBrightnessIcon from '@mui/icons-material/SettingsBrightness';
import FormatTextdirectionLToRIcon from '@mui/icons-material/FormatTextdirectionLToR';
import FormatTextdirectionRToLIcon from '@mui/icons-material/FormatTextdirectionRToL';
import { useColorSchemeShim, useChangeTheme } from 'docs/src/modules/components/ThemeContext';
import { useTranslate } from '@mui/docs/i18n';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var Heading = styled(Typography)(function (_ref) {
  var theme = _ref.theme;
  return {
    margin: '16px 0 8px',
    fontWeight: theme.typography.fontWeightSemiBold,
    fontSize: theme.typography.pxToRem(11),
    textTransform: 'uppercase',
    letterSpacing: '.1rem',
    color: (theme.vars || theme).palette.text.tertiary
  };
});
var IconToggleButton = styled(ToggleButton)({
  display: 'flex',
  justifyContent: 'center',
  width: '100%',
  '& > *': {
    marginRight: '8px'
  }
});
function ToggleTheme(props) {
  var value = props.value,
    onChange = props.onChange;
  var t = useTranslate();
  return /*#__PURE__*/_jsxs(ToggleButtonGroup, {
    exclusive: true,
    value: value,
    color: "primary",
    onChange: onChange,
    "aria-labelledby": "settings-mode",
    fullWidth: true,
    children: [/*#__PURE__*/_jsxs(IconToggleButton, {
      value: "light",
      "aria-label": t('settings.light'),
      "data-ga-event-category": "settings",
      "data-ga-event-action": "light",
      children: [/*#__PURE__*/_jsx(LightModeIcon, {
        fontSize: "small"
      }), t('settings.light')]
    }), /*#__PURE__*/_jsxs(IconToggleButton, {
      value: "system",
      "aria-label": t('settings.system'),
      "data-ga-event-category": "settings",
      "data-ga-event-action": "system",
      children: [/*#__PURE__*/_jsx(SettingsBrightnessIcon, {
        fontSize: "small"
      }), t('settings.system')]
    }), /*#__PURE__*/_jsxs(IconToggleButton, {
      value: "dark",
      "aria-label": t('settings.dark'),
      "data-ga-event-category": "settings",
      "data-ga-event-action": "dark",
      children: [/*#__PURE__*/_jsx(DarkModeOutlinedIcon, {
        fontSize: "small"
      }), t('settings.dark')]
    })]
  });
}
false ? void 0 : void 0;
function ToggleVarTheme(props) {
  var _useColorScheme = useColorScheme(),
    setMode = _useColorScheme.setMode;
  var handleChangeThemeMode = function handleChangeThemeMode(event, paletteMode) {
    if (paletteMode === null) {
      return;
    }
    props.onChange(event, paletteMode);
    setMode(paletteMode);
  };
  return /*#__PURE__*/_jsx(ToggleTheme, {
    value: props.value,
    onChange: handleChangeThemeMode
  });
}
false ? void 0 : void 0;
export default function AppSettingsDrawer(props) {
  var onClose = props.onClose,
    _props$open = props.open,
    open = _props$open === void 0 ? false : _props$open,
    other = _objectWithoutPropertiesLoose(props, _excluded);
  var t = useTranslate();
  var upperTheme = useTheme();
  var changeTheme = useChangeTheme();

  // TODO replace with useColorScheme once all pages support css vars
  var _useColorSchemeShim = useColorSchemeShim(),
    mode = _useColorSchemeShim.mode,
    setMode = _useColorSchemeShim.setMode;
  var handleChangeThemeMode = function handleChangeThemeMode(event, paletteMode) {
    if (paletteMode === null) {
      return;
    }
    setMode(paletteMode);
  };
  var handleChangeDirection = function handleChangeDirection(event, direction) {
    if (direction === null) {
      direction = upperTheme.direction;
    }
    changeTheme({
      direction: direction
    });
  };
  return /*#__PURE__*/_jsxs(Drawer, _extends({
    anchor: "right",
    onClose: onClose,
    open: open,
    PaperProps: {
      elevation: 0,
      sx: {
        width: {
          xs: 310,
          sm: 360
        },
        borderRadius: '10px 0px 0px 10px',
        border: '1px solid',
        borderColor: 'divider'
      }
    }
  }, other, {
    children: [/*#__PURE__*/_jsxs(Box, {
      sx: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        px: 2,
        py: 1
      },
      children: [/*#__PURE__*/_jsx(Typography, {
        variant: "body1",
        sx: {
          fontWeight: 'medium'
        },
        children: t('settings.settings')
      }), /*#__PURE__*/_jsx(IconButton, {
        color: "inherit",
        onClick: onClose,
        edge: "end",
        "aria-label": t('close'),
        children: /*#__PURE__*/_jsx(CloseIcon, {
          color: "primary",
          fontSize: "small"
        })
      })]
    }), /*#__PURE__*/_jsx(Divider, {}), /*#__PURE__*/_jsxs(Box, {
      sx: {
        pl: 2,
        pr: 2
      },
      children: [/*#__PURE__*/_jsx(Heading, {
        gutterBottom: true,
        id: "settings-mode",
        children: t('settings.mode')
      }), upperTheme.vars ? /*#__PURE__*/_jsx(ToggleVarTheme, {
        value: mode,
        onChange: handleChangeThemeMode
      }) : /*#__PURE__*/_jsx(ToggleTheme, {
        value: mode,
        onChange: handleChangeThemeMode
      }), /*#__PURE__*/_jsx(Heading, {
        gutterBottom: true,
        id: "settings-direction",
        children: t('settings.direction')
      }), /*#__PURE__*/_jsxs(ToggleButtonGroup, {
        exclusive: true,
        value: upperTheme.direction,
        onChange: handleChangeDirection,
        "aria-labelledby": "settings-direction",
        color: "primary",
        fullWidth: true,
        children: [/*#__PURE__*/_jsxs(IconToggleButton, {
          value: "ltr",
          "aria-label": t('settings.ltr'),
          "data-ga-event-category": "settings",
          "data-ga-event-action": "ltr",
          children: [/*#__PURE__*/_jsx(FormatTextdirectionLToRIcon, {
            fontSize: "small"
          }), t('settings.ltr')]
        }), /*#__PURE__*/_jsxs(IconToggleButton, {
          value: "rtl",
          "aria-label": t('settings.rtl'),
          "data-ga-event-category": "settings",
          "data-ga-event-action": "rtl",
          children: [/*#__PURE__*/_jsx(FormatTextdirectionRToLIcon, {
            fontSize: "small"
          }), t('settings.rtl')]
        })]
      }), /*#__PURE__*/_jsx(Heading, {
        gutterBottom: true,
        children: t('settings.color')
      }), /*#__PURE__*/_jsx(Button, {
        component: "a",
        href: "/material-ui/customization/color/#playground",
        "data-ga-event-category": "settings",
        "data-ga-event-action": "colors",
        variant: "outlined",
        size: "small",
        fullWidth: true,
        children: t('settings.editDocsColors')
      })]
    })]
  }));
}
false ? void 0 : void 0;